import { ChangeEvent, useEffect } from 'react';
import { useController, UseControllerProps } from 'react-hook-form';
import { sanitizeText } from '../utils/textValidation';

// Shared by textboxes and textareas so individual Yup schemas need no changes.
export default function useSanitizedTextController(props: UseControllerProps) {
  const controller = useController(props);
  const { value, onChange } = controller.field;
  const cleanValue = typeof value === 'string' ? sanitizeText(value) : value;

  // Also clean values populated by defaultValues, reset or setValue (e.g. cloning).
  useEffect(() => {
    if (value !== cleanValue) {
      onChange(cleanValue);
    }
  }, [value, cleanValue, onChange]);

  return {
    ...controller,
    field: {
      ...controller.field,
      value: cleanValue,
      onChange: (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const cleaned = sanitizeText(event.target.value);
        // Keep the DOM in sync even when removing characters leaves form state unchanged.
        event.target.value = cleaned;
        onChange(cleaned);
      }
    }
  };
}
